import { WorkCenter } from '../workcenters/work-center'

export class ShopfloorLayoutSpecNode {
  constructor(
    public id: string,
    public label: string,
    public workCenter: WorkCenter | null
  ) {}
}
